// extracted by mini-css-extract-plugin
export var container = "styles-module--container--2XSdw";
export var backAndForthRight = "styles-module--backAndForthRight--ev9gD";
export var wobbleRightAndLeft = "styles-module--wobbleRightAndLeft--vIY9f";
export var animateBg = "styles-module--animateBg--VCsCb";